// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2e967d1b","453":"f78790fd","732":"335fb2dd","977":"a577c70b"}[chunkId] + ".chunk.js";
};